import { render, staticRenderFns } from "./OrgDemandsOverdue.vue?vue&type=template&id=61691ee4&scoped=true&"
import script from "./OrgDemandsOverdue.vue?vue&type=script&lang=js&"
export * from "./OrgDemandsOverdue.vue?vue&type=script&lang=js&"
import style0 from "./OrgDemandsOverdue.vue?vue&type=style&index=0&id=61691ee4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61691ee4",
  null
  
)

export default component.exports